import axios from "axios";

export let baseUrl = `${process.env.REACT_APP_BASE_URL}api/`;
export const socketUrl = process.env.REACT_APP_BASE_URL;

const api = async (path, params, method) => {
  const lang = localStorage.getItem("currentLang") || "ro";

  const userStr = localStorage.getItem("user_data_admin");
  const token = userStr ? JSON.parse(userStr).token : null;

  let options;
  options = {
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": lang,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    method: method,
    ...(params && { data: JSON.stringify(params) }),
  };
  return axios(baseUrl + path, options)
    .then((response) => {
      return response;
    })
    .catch(async (error) => {
      console.info(error)
      return error.response;
    });
};

export default api;
